







import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import LoginBox from "@/components/LoginBox.vue";
import { PromiseService } from "@/service/PromiseService";

@Component({
  components: {
    Header,
    LoginBox
  }
})
export default class FactoryLogin extends Vue {
  onSubmit() {
    /** 2021-07-30 sh #6989 refactoring [START] */
    // this.$router.push("/factory/reservation");
    const promiseService = new PromiseService();
    const promise = promiseService.getFunctionSettingPM();

    Promise.all([promise]).then(() => {
      this.$router.push("/factory/reservation");
    });
    /** 2021-07-30 sh #6989 refactoring [END] */
  }
}
